<template>
  <div class="add-label-container max-h-[550px] h-auto overflow-auto flex flex-col noscroll-bar">
    <div class="modal-header-wrapper sticky-header">
      <woot-modal-header :header-title="$t('LABEL_MGMT.ADD.TITLE')" :header-content="$t('LABEL_MGMT.ADD.DESC')" />
      <woot-button
        color-scheme="secondary"
        icon="dismiss"
        variant="clear"
        class="modal-close-btn"
        @click="onClose"
      />
    </div>
     <div class="modal-body-scroll">
    <form class="mx-0 flex flex-wrap" @submit.prevent="addLabel">
      <!-- <woot-input
        v-model.trim="title"
        :class="{ error: $v.title.$error }"
        class="w-full label-name--input"
        :label="$t('LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="getLabelTitleErrorMessage"
        data-testid="label-title"
        @input="$v.title.$touch"
      /> -->
      <label class="label-name-label">
        {{ $t('LABEL_MGMT.FORM.NAME.LABEL') }}
        <span class="required-asterisk">*</span>
      </label>
      <woot-input v-model.trim="title" :class="{ error: $v.title.$error }" class="w-full label-name--input"
        :placeholder="$t('LABEL_MGMT.FORM.NAME.PLACEHOLDER')" :error="getLabelTitleErrorMessage"
        data-testid="label-title" @input="$v.title.$touch" />

      <woot-input v-model.trim="description" :class="{ error: $v.description.$error }" class="w-full"
        :label="$t('LABEL_MGMT.FORM.DESCRIPTION.LABEL')" :placeholder="$t('LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        data-testid="label-description" @input="$v.description.$touch" />


            <!-- Contact Automation UI - Shows first when enabled -->
      <div class="automation-section-heading" v-if="forContactAutomation">
        Contact Automation
      </div>
      <div class="contact-automation-modal w-full" v-if="forContactAutomation">
        <div class="w-full">
          <div class="contact-automation-data">
            <div class="inbox-select">
              <label :class="{ error: $v.contactAutomationData.inbox_id.$error }">
                {{ $t('LABEL_MGMT.FORM.INBOX.LABEL') }}
              </label>
              <multiselect
                ref="inboxMultiselect"
                :value="selectedInbox"
                @select="onInboxSelect"
                @close="$v.contactAutomationData.inbox_id.$touch"
                track-by="id"
                label="name"
                :placeholder="$t('LABEL_MGMT.FORM.INBOX.PLACEHOLDER')"
                :options="inboxOptions"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                :close-on-select="true"
                deselect-label=""
                select-label=""
                selected-label=""
              >
                <template #option="{ option }">
                  <div class="option-content" @click="closeInboxDropdown">{{ option.name }}</div>
                </template>
              </multiselect>
              <span v-if="getContactAutomationInboxErrorMessage()" class="text-red-500 text-sm">
                {{ getContactAutomationInboxErrorMessage() }}
              </span>
            </div>

            <div class="label-select">
              <label :class="{ error: $v.contactAutomationData.label_id.$error }">
                <span class="label-with-info">
                  {{ $t('LABEL_MGMT.FORM.CONTACT_AUTOMATION_LABEL.LABEL') }}
                  <fluent-icon 
                    v-if="isBothAutomationsEnabled"
                    icon="info"
                    size="14"
                    class="info-icon"
                    v-tooltip.top="$t('LABEL_MGMT.FORM.CONTACT_AUTOMATION_LABEL.AUTO_SELF_MESSAGE')"
                  />
                </span>
              </label>
              <multiselect
                ref="labelMultiselect"
                :value="selectedLabel"
                @select="onLabelSelect"
                @close="$v.contactAutomationData.label_id.$touch"
                track-by="id"
                label="name"
                :placeholder="$t('LABEL_MGMT.FORM.CONTACT_AUTOMATION_LABEL.PLACEHOLDER')"
                :options="labelOptions"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                :close-on-select="true"
                :disabled="isBothAutomationsEnabled"
                :class="{ 'hide-arrow': contactAutomationData.label_id === 'self' }"
                deselect-label=""
                select-label=""
                selected-label=""
              >
                <template #option="{ option }">
                  <div class="option-content" @click="closeLabelDropdown">{{ option.name }}</div>
                </template>
              </multiselect>
              <span v-if="getContactAutomationLabelErrorMessage()" class="text-red-500 text-sm">
                {{ getContactAutomationLabelErrorMessage() }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Regular Automation UI - Shows below contact automation -->
      <div class="automation-section-heading" v-if="forAutomation">
        Conversation Automation
      </div>
      <div class="demo-modal w-full" v-if="forAutomation">
        <div class="w-full">
          <div class="demo-data" v-for="(data, index) in dataList" :key="index">
            <div class="macro">
              <label :class="{ error: $v.dataList.$each[index] &&
                          $v.dataList.$each[index].is_before.$error }">
                {{ $t('LABEL_MGMT.FORM.AUTOMATION.LABEL') }}
              </label>
              <multiselect
                :value="getAutomationOption(data.is_before)"
                @input="onAutomationSelect($event, index)"
                @close="$v.dataList.$each[index].is_before.$touch"
                track-by="id"
                label="name"
                placeholder="Select"
                :options="automationOptions"
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
                :close-on-select="true"
                deselect-label=""
                select-label=""
                selected-label=""
              >
              </multiselect>
              <span v-if="getAutomationErrorMessage(index)" class="text-red-500 text-sm">
                {{ getAutomationErrorMessage(index)}}
              </span>
            </div>
            <div class="time-unit">
              <label>
                {{ $t('LABEL_MGMT.FORM.TIME_UNIT') }}
              </label>
              <multiselect
                :value="getTimeUnitOption(data.time_unit)"
                @input="onTimeUnitSelect($event, index)"
                track-by="id"
                label="name"
                :placeholder="'Select'"
                :options="timeUnitOptions"
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
                :close-on-select="true"
                deselect-label=""
                select-label=""
                selected-label=""
              >
              </multiselect>
            </div>
            <div class="triggeredBefore">
              <label :class="{ error: $v.dataList.$each[index] ? $v.dataList.$each[index].trigger_before.$error : false }">
                {{ $t(`LABEL_MGMT.FORM.${data.is_before ? 'TRIGGEREDBEFORE' : 'TRIGGEREDAFTER'}.LABEL`) }}
              </label>
              <woot-input
                v-model.trim="data.trigger_before"
                :class="{ error: $v.dataList.$each[index] ? $v.dataList.$each[index].trigger_before.$error : false }"
                type="number"
                min="1"
                step="1"
                :placeholder="$t(`LABEL_MGMT.FORM.${data.is_before ? 'TRIGGEREDBEFORE' : 'TRIGGEREDAFTER'}.PLACEHOLDER_${data.time_unit?.toUpperCase()}`)"
                data-testid="label-triggeredBefore"
                :error="getTriggerBeforeErrorMessage(index)"
                @input="handleTriggerBeforeInput($event, index)"
                @keydown="preventNegativeInput"
              />
            </div>
            <div class="macro">
              <label :class="{ error: $v.dataList.$each[index] && $v.dataList.$each[index].macro_id.$error }">
                {{ $t('LABEL_MGMT.FORM.MACRO.LABEL') }}
              </label>
              <multiselect
                :ref="`macroMultiselect${index}`"
                :value="getMacroOption(data.macro_id)"
                @select="onMacroSelect($event, index)"
                @close="$v.dataList.$each[index].macro_id.$touch"
                track-by="id"
                label="name"
                :placeholder="$t('LABEL_MGMT.FORM.MACRO.PLACEHOLDER')"
                :options="macroOptions"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                :close-on-select="true"
                deselect-label=""
                select-label=""
                selected-label=""
              >
                <template #option="{ option }">
                  <div class="option-content" @click="closeMacroDropdown(index)">{{ option.name }}</div>
                </template>
              </multiselect>
              <span v-if="getMacroIdErrorMessage(index)" class="text-red-500 text-sm">
                {{ getMacroIdErrorMessage(index) }}
              </span>
            </div>

            <div class="delete-button">
              <woot-button v-tooltip="'Delete Trigger'" icon="delete" variant="smooth" size="small"
                color-scheme="alert" @click="removeData(index)" />
            </div>
          </div>
        </div>
      </div>
      <div class="add-button" @click="addData" v-if="forAutomation">
        {{ $t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.ADDMACRO') }}
      </div>
      <div class="w-full">
        <label>
          {{ $t('LABEL_MGMT.FORM.COLOR.LABEL') }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      
      <div class="w-full">
        <input v-model="showOnSidebar" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.LABEL') }}
        </label>
      </div>

      <div class="w-full">
        <input v-model="forAutomation" type="checkbox" :value="true" />
        <label for="conversation_creation">{{ $t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.AUTOMATION') }}
        </label>
      </div>

      <div class="w-full">
        <input v-model="forContactAutomation" type="checkbox" :value="true" />
        <label for="contact_automation">{{ $t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.CONTACT_AUTOMATION') }}
        </label>
      </div>
      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-disabled="$v.title.$invalid || uiFlags.isCreating" :is-loading="uiFlags.isCreating"
          data-testid="label-submit">
          {{ $t('LABEL_MGMT.FORM.CREATE') }}
        </woot-button>
        <woot-button class="button clear" @click.prevent="onClose">
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import validationMixin from './validationMixin';
import { mapGetters } from 'vuex';
import validations from './validations';
import { getRandomColor } from 'dashboard/helper/labelColor';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  mixins: [alertMixin, validationMixin],
  props: {
    prefillTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      color: '#000',
      description: '',
      dataList: [
        {
          macro_id: '',
          trigger_before: '',
          time_unit: 'second',
          is_before: true,
        },
      ],
      contactAutomationData: {
        inbox_id: '',
        label_id: '',
      },
      title: '',
      showOnSidebar: true,
      forAutomation: false,
      forContactAutomation: false,
      selectedValue: 'Before',
      status: {
        id: '',
        name: this.$t('CONTACT_FORM.FORM.STATUS.SELECT_STATUS'),
      },
    };
  },
  validations,
  computed: {
    ...mapGetters({
      records: ['macros/getMacros'],
      uiFlags: 'labels/getUIFlags',
      inboxes: 'inboxes/getInboxes',
      allLabels: 'labels/getLabels',
    }),
    getStatus() {
      return this.$store.getters['pipelines/getAllState'];
    },
    isBothAutomationsEnabled() {
      return this.forAutomation && this.forContactAutomation;
    },
    availableLabels() {
      // Filter labels that have automation: true and exclude the current label being created
      const automationLabels = this.allLabels.filter(label => 
        label.automation === true && label.title !== this.title.toLowerCase()
      );
      
      // If both automations are enabled, show only "Self" option
      if (this.isBothAutomationsEnabled) {
        return [{
          id: 'self',
          title: this.$t('LABEL_MGMT.FORM.CONTACT_AUTOMATION_LABEL.SELF')
        }];
      }
      
      // If only contact automation is enabled, show only automation type labels (no "Self" option)
      if (this.forContactAutomation && !this.forAutomation) {
        return automationLabels;
      }
      
      // Default: show "Self" + automation labels (shouldn't reach here with current logic)
      const selfOption = {
        id: 'self',
        title: this.$t('LABEL_MGMT.FORM.CONTACT_AUTOMATION_LABEL.SELF')
      };
      return [selfOption, ...automationLabels];
    },
    timeUnitOptions() {
      return [
        { id: 'hour', name: this.$t('LABEL_MGMT.FORM.UNIT.HOUR') },
        { id: 'minute', name: this.$t('LABEL_MGMT.FORM.UNIT.MINUTE') },
        { id: 'second', name: this.$t('LABEL_MGMT.FORM.UNIT.SECOND') },
      ];
    },
    automationOptions() {
      return [
        { id: true, name: this.$t('LABEL_MGMT.FORM.AUTOMATION.TRUE') },
        { id: false, name: this.$t('LABEL_MGMT.FORM.AUTOMATION.FALSE') },
      ];
    },
    inboxOptions() {
      return this.inboxes.map(inbox => ({
        id: inbox.id,
        name: inbox.name
      }));
    },
    macroOptions() {
      return this.records.map(record => ({
        id: record.id,
        name: record.name
      }));
    },
    labelOptions() {
      return this.availableLabels.map(label => ({
        id: label.id,
        name: label.title
      }));
    },
    selectedInbox() {
      return this.inboxOptions.find(inbox => inbox.id === this.contactAutomationData.inbox_id) || null;
    },
    selectedLabel() {
      return this.labelOptions.find(label => label.id === this.contactAutomationData.label_id) || null;
    },
  },
  watch: {
    isBothAutomationsEnabled(newValue) {
      if (newValue) {
        // Auto-select "self" when both automations are enabled
        this.contactAutomationData.label_id = 'self';
      } else if (this.contactAutomationData.label_id === 'self' && !this.forAutomation) {
        // Clear selection if only contact automation is enabled (self not available)
        this.contactAutomationData.label_id = '';
      }
    },
  },

  mounted() {
    this.$store.dispatch('macros/get');
    this.$store.dispatch('inboxes/get');
    this.ensureLabelsLoaded();
    this.color = getRandomColor();
    this.title = this.prefillTitle.toLowerCase();
    
    this.$store.dispatch('pipelines/getStatus');
  },
  methods: {
    async ensureLabelsLoaded() {
      if (this.allLabels.length) return;

      if (this.uiFlags.isFetching) {
        await new Promise(resolve => {
          const unwatch = this.$watch(
            () => this.uiFlags.isFetching,
            isFetching => {
              if (!isFetching) {
                unwatch();
                resolve();
              }
            }
          );
          if (!this.uiFlags.isFetching) {
            unwatch();
            resolve();
          }
        });
      }

      if (!this.allLabels.length) {
        await this.$store.dispatch('labels/get');
      }
    },
    onClose() {
      this.$emit('close');
    },
    // Multiselect handlers for Contact Automation
    onInboxSelect(selected) {
      this.contactAutomationData.inbox_id = selected ? selected.id : '';
    },
    closeInboxDropdown() {
      // Small delay to let selection complete first
      setTimeout(() => {
        if (this.$refs.inboxMultiselect && this.$refs.inboxMultiselect.isOpen) {
          this.$refs.inboxMultiselect.deactivate();
        }
      }, 50);
    },
    onLabelSelect(selected) {
      this.contactAutomationData.label_id = selected ? selected.id : '';
    },
    closeLabelDropdown() {
      // Small delay to let selection complete first
      setTimeout(() => {
        if (this.$refs.labelMultiselect && this.$refs.labelMultiselect.isOpen) {
          this.$refs.labelMultiselect.deactivate();
        }
      }, 50);
    },
    // Multiselect handlers for regular automation
    onTimeUnitSelect(selected, index) {
      if (selected) {
        this.dataList[index].time_unit = selected.id;
      }
    },
    onMacroSelect(selected, index) {
      if (selected) {
        this.dataList[index].macro_id = selected.id;
      }
      // Touch validation
      if (this.$v.dataList.$each[index]) {
        this.$v.dataList.$each[index].macro_id.$touch();
      }
    },
    closeMacroDropdown(index) {
      // Small delay to let selection complete first
      setTimeout(() => {
        const ref = this.$refs[`macroMultiselect${index}`];
        if (ref) {
          const instance = Array.isArray(ref) ? ref[0] : ref;
          if (instance && instance.isOpen) {
            instance.deactivate();
          }
        }
      }, 50);
    },
    onAutomationSelect(selected, index) {
      if (selected) {
        this.dataList[index].is_before = selected.id;
      }
    },
    // Helper methods to get selected option objects
    getTimeUnitOption(timeUnit) {
      return this.timeUnitOptions.find(option => option.id === timeUnit) || null;
    },
    getMacroOption(macroId) {
      return this.macroOptions.find(option => option.id === macroId) || null;
    },
    getAutomationOption(isBefore) {
      return this.automationOptions.find(option => option.id === isBefore) || null;
    },
    async addLabel() {
      this.$v.$touch();

      if (this.$v.title.$invalid) {
        return;
      }

      if (this.forAutomation && this.$v.dataList.$invalid) {
        return;
      }

      if (this.forContactAutomation && this.$v.contactAutomationData.$invalid) {
        return;
      }
      const statusPayload = {
        id: this.status.id,
        name: this.status.name
      };
      const normalizedDataList = this.normalizeDataList(this.dataList);
      const contactAutomationTrigger = this.forContactAutomation ? [{
        inbox_id: this.contactAutomationData.inbox_id,
        target_label_id: this.contactAutomationData.label_id === 'self' ? null : this.contactAutomationData.label_id,
        apply_self: this.contactAutomationData.label_id === 'self',
      }] : [];
      try {
        await this.$store.dispatch('labels/create', {
          color: this.color,
          status: statusPayload,
          description: this.description,
          title: this.title.toLowerCase(),
          show_on_sidebar: this.showOnSidebar,
          label_triggers_attributes: normalizedDataList,
          contact_automation_triggers_attributes: contactAutomationTrigger,
          automation: this.forAutomation,
          contact_automation: this.forContactAutomation,
        });
        this.showAlert(this.$t('LABEL_MGMT.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('LABEL_MGMT.ADD.API.ERROR_MESSAGE');
        this.showAlert(errorMessage);
      }
    },
    addData() {
      this.dataList.push({
        trigger_before: '',
        macro_id: '',
        is_before: true,
        time_unit: 'second',
      });
    },
    removeData(index) {
      this.dataList.splice(index, 1);
    },
    normalizeDataList() {
      return this.dataList.map(item => {
        let value = Number(item.trigger_before) || 0;

        switch (item.time_unit) {
          case 'hour':
            value *= 3600;
            break;
          case 'minute':
            value *= 60;
            break;
          case 'second':
          default:
            value *= 1;
        }

        return {
          trigger_before: value,
          macro_id: item.macro_id,
          is_before: item.is_before,
          time_unit: item.time_unit,
        };
      });
    },
    // Prevent negative input and ensure only positive natural numbers
    handleTriggerBeforeInput(event, index) {
      let value = this.dataList[index].trigger_before;
      // Remove any non-digit characters and leading zeros
      value = value.toString().replace(/[^0-9]/g, '').replace(/^0+/, '');
      // Ensure minimum value of 1 if not empty
      if (value !== '' && parseInt(value, 10) < 1) {
        value = '1';
      }
      this.dataList[index].trigger_before = value;
      if (this.$v.dataList.$each[index]) {
        this.$v.dataList.$each[index].trigger_before.$touch();
      }
    },
    // Prevent negative sign, decimal point, and 'e' from being entered
    preventNegativeInput(event) {
      if (event.key === '-' || event.key === 'e' || event.key === 'E' || event.key === '.' || event.key === '+') {
        event.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// Container styling
.add-label-container {
   height: 100%;
  display: flex;
  flex-direction: column;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 20;
  padding-bottom: 12px !important;
}

.modal-body-scroll {
  flex: 1;
  overflow-y: auto;
  max-height: 550px;
}

// Header wrapper with close button
.modal-header-wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
  
  :deep(.flex.flex-col.items-start) {
    flex: 1;
    padding-right: 40px;
  }
}

// Close button that scrolls with content
.modal-close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

// Label API supports only lowercase letters
.label-name--input {
  :deep {
    input {
      @apply lowercase;
      
      &::placeholder {
        text-transform: none;
      }
    }
  }
}

// Custom label styling with asterisk
.label-name-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  
  .required-asterisk {
    color: #ef4444;
    margin-left: 4px;
    font-size: 14px;
    font-weight: 600;
  }
}
.demo-modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.demo-data {
  display: flex;
  align-items: flex-start;
  column-gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  flex-wrap: wrap;
  position: relative;
  padding-right: 50px;
}
.delete-button {
  position: absolute;
  bottom: 32px;
  right: 10px;
}
.add-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  font-size: 12px;
  background: aliceblue;
  font-weight: 500;
  border-radius: 5px;
  margin-top: 10px;
}
.time-unit {
  flex: 0 0 120px;
  min-width: 120px;
  
  label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }
  
  select {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 13px;
  }
}
.macro {
  flex: 1;
  min-width: 140px;
  max-width: 180px;
  
  label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }
  
  select {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 13px;
  }
}
.triggeredBefore {
  flex: 0 0 150px;
  min-width: 150px;
  
  // Match label styling with Time Unit, Macro, and Automation
  label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }
  
  // Match input and placeholder styling with multiselect dropdown
  :deep(input) {
    min-height: 40px !important;
    max-height: 40px !important;
    padding: 8px 12px !important;
    border: 1.5px solid #d1d5db !important;
    border-radius: 6px !important;
    font-size: 14px !important;
    background: #ffffff !important;
    
    &::placeholder {
      font-size: 14px !important;
      color: #9ca3af !important;
      line-height: 1.5 !important;
    }
  }
  
  // Hide the label from woot-input component since we're using our own
  :deep(.input-container > span) {
    display: none;
  }
}
:deep(.colorpicker) {

  position: relative;
}
:deep(.colorpicker--selected) {

  width: 32px;
  height: 32px;
  cursor: pointer;  
  border-radius: 5px;
  margin-bottom: 5px;
}
:deep(.colorpicker--dropdown) {

  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 5px;
}
.noscroll-bar::-webkit-scrollbar {
  display: none; 
}
[data-testid="label-submit"] {
  background-color: #40518a !important;
  color: white !important;
}
.contact-automation-modal {
  display: flex;
  flex-direction: column;
  gap: 12px;
 
}
.contact-automation-data {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  flex-wrap: wrap;
}
.inbox-select,
.label-select {
  flex: 1;
  min-width: 200px;
  
  label {
    display: block;
    margin-bottom: 2px;
    font-size: 12px;
    font-weight: 500;
    color: #374151;
  }
  
  .label-with-info {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    
    .info-icon {
      color: #3b82f6;
      cursor: help;
    }
  }
  
  select {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 13px;
  }
}

// Multiselect styling
:deep(.multiselect) {
  min-height: 40px;
  max-height: 40px;
  font-size: 14px;
}

:deep(.multiselect__tags) {
  min-height: 40px !important;
  max-height: 40px !important;
  padding: 8px 40px 8px 12px !important;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
}

// Ensure tags container stays consistent when dropdown is open
:deep(.multiselect--active .multiselect__tags) {
  min-height: 40px !important;
  max-height: 40px !important;
  padding: 8px 40px 8px 12px !important;
}

  :deep(.multiselect__input) {
    font-size: 14px;
    padding: 0;
    min-height: auto;
    line-height: 1.5;
    border: none !important;
    box-shadow: none !important;
  }
  
  :deep(.multiselect__input:focus) {
    outline: none !important;
    height: 96% !important;
    width: 93% !important;
  }

:deep(.multiselect__single) {
  font-size: 14px;
  margin-bottom: 0;
  padding: 0;
  line-height: 1.5;
  color: #1f2937;
}

:deep(.multiselect__placeholder) {
  font-size: 14px !important;
  color: #9ca3af;
  padding: 0 !important;
  margin-bottom: 0 !important;
  line-height: 1.5 !important;
  white-space: nowrap;
  overflow: hidden;
  display: block;
}

// Ensure placeholder doesn't change when dropdown is open
:deep(.multiselect--active .multiselect__placeholder) {
  font-size: 14px !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
  line-height: 1.5 !important;
}

:deep(.multiselect__select) {
  height: 40px;
  width: 40px;
  padding: 4px 8px;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0px;
}

:deep(.multiselect__select:before) {
  border-color: #6b7280 transparent transparent;
  border-width: 5px 5px 0;
  position: static;
  margin: 0;
}

:deep(.multiselect__content-wrapper) {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  margin-top: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  max-height: 240px;
  overflow-y: auto;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }
  
  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

:deep(.multiselect__content) {
  width: 100%;
  display: inline-block;
}

:deep(.multiselect__option) {
  font-size: 14px;
  padding: 0;
  min-height: 40px;
  line-height: 20px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
    padding: 10px 12px;
  }
  
  .option-content {
    padding: 10px 12px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
  }
}

.multiselect:not(.no-margin) {
     margin-bottom: 0 !important; 
}

:deep(.multiselect__option--highlight) {
  background: #eff6ff;
  color: #1e40af;
  
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

:deep(.multiselect__option--selected) {
  background: #dbeafe;
  color: #1e40af;
  font-weight: 500;
}

:deep(.multiselect__option--selected.multiselect__option--highlight) {
  background: #bfdbfe;
  color: #1e3a8a;
}

:deep(.multiselect--disabled) {
  background: #f3f4f6;
  opacity: 0.7;
  
  .multiselect__tags {
    background: #f3f4f6;
    border-color: #e5e7eb;
  }
  
  .multiselect__single {
    background: #f3f4f6;
    color: #9ca3af;
  }
}

// Dark mode for multiselect
.dark {
  :deep(.multiselect__tags) {
    background: #1f2937;
    border-color: #374151;
  }
  
  :deep(.multiselect__single) {
    color: #f3f4f6;
  }

  .multiselect:not(.no-margin) {
     margin-bottom: 0 !important; 
  }
  
  :deep(.multiselect__placeholder) {
    color: #6b7280;
  }
  
  :deep(.multiselect__content-wrapper) {
    background: #1f2937;
    border-color: #374151;
  }
  
  :deep(.multiselect__option) {
    color: #f3f4f6;
  }
  
  :deep(.multiselect__option--highlight) {
    background: #374151;
    color: #60a5fa;
  }
  
  :deep(.multiselect__option--selected) {
    background: #1e3a8a;
    color: #93c5fd;
  }
  
  :deep(.multiselect--disabled) {
    .multiselect__tags {
      background: #111827;
      border-color: #374151;
    }
  }
}

// Override error state for multiselect - prevent red border on input
label.error {
  :deep(.multiselect__input) {
    border: none !important;
    box-shadow: none !important;
  }
  
  :deep(.multiselect__tags) {
    border-color: #d1d5db !important;
  }
}

// Reduce spacing for error messages
.text-red-500 {
  display: block;
  margin-top: 2px;
}

// Hide dropdown arrow when "self" is selected
:deep(.multiselect.hide-arrow) {
  .multiselect__select {
    display: none;
  }
  
  .multiselect__single {
    max-width: 100%;
  }
}

// Automation section heading
.automation-section-heading {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-top: 16px;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
</style>
